import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3eb073a4/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListInput, StructuredListCell, OrderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The accordion React Carbon component has been tested against the latest `}<a parentName="p" {...{
          "href": "https://www.w3.org/TR/WCAG21/"
        }}>{`W3C
Web Content Accessibility Guidelines (WCAG) 2.1 Level A and AA success
criteria`}</a>{` and violations have been identified
as high priority issues. This document will be updated when these
accessibility issues are resolved.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">How it works</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility considerations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility testing</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p>{`The accordion Carbon component provides a vertically stacked layout for web content, commonly used to reduce scrolling. The accordion header is a button that is used to expand and collapse each accordion panel. Buttons are used so that the accordions are tab-able by keyboard users and accessible to screen readers. Tab key and Shift-Tab keys are used to navigate through each accordion header and all focusable elements in the accordion should be included in the page Tab sequence. The Enter or Space key expand and collapse each accordion panel.`}</p>
    <p>{`WAI-ARIA roles and states are used to ensure the component is accessible to people using assistive technologies. The accordion component is assigned the ARIA `}<inlineCode parentName="p">{`role="presentation"`}</inlineCode>{` because it is used to layout web content. When an accordion panel is collapsed the content is hidden so the ARIA state, `}<inlineCode parentName="p">{`aria-expanded="false"`}</inlineCode>{` advises users of assistive technologies that the accordion panel is not visible. When the accordion header is expanded the ARIA state changes to `}<inlineCode parentName="p">{`aria-expanded="true"`}</inlineCode>{` and the accordion panel content is displayed. Each accordion header contains an ARIA label, and the header buttons have a aria-control property set that points to the unique id of the panel it controls. When focus is on the Accordion header there is a prominent style change to the border as well as background of the accordion header.`}</p>
    <h2 {...{
      "id": "accessibility-considerations"
    }}>{`Accessibility considerations`}</h2>
    <p>{`This component has been validated to meet the `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20/"
      }}>{`WCAG 2.0 AA`}</a>{` and `}<a parentName="p" {...{
        "href": "http://www.section508.gov/"
      }}>{`Section 508`}</a>{` accessibility guidelines, however changes made by the content owner can affect accessibility compliance. Be sure to review and follow the guidance in this section when updating or adding new content to this component.`}</p>
    <ol>
      <li parentName="ol">{`Each accordion header must have a unique title (implemented via the label for the button) that clearly describes the accordion panel content. This is particularly helpful for users of assistive technologies so they have the necessary information to efficiently navigate the content without having to expand every section.`}</li>
      <li parentName="ol">{`Carbon components should be used to create the content that displays within each accordion panel.`}</li>
      <li parentName="ol">{`Avoid keyboard traps when adding components to the accordion panel. For example, the user expands an accordion, but is unable to tab to the next focusable element.`}</li>
      <li parentName="ol">{`Although the accordion component passes accessibility testing, content authors need to ensure the content that is added to the accordion is accessible. For example, if you add an image to the accordion header or panel you need to include alternative text to pass accessibility testing.`}</li>
    </ol>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/TR/wai-aria-practices/#accordion"
        }}>{`W3C WAI-ARIA Authoring Practices Accordion Design Pattern`}</a>{` covers the usage of ARIA names, state and roles, as well as the expected keyboard interactions.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/able/guidelines/ci162/accessibility_checklist.html"
        }}>{`IBM Accessibility Checklist Checkpoint:`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html"
            }}>{`1.3.1 Info and Relationships`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/info-and-relationships"
            }}>{`1.3.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/meaningful_sequence.html"
            }}>{`1.3.2 Meaningful Sequence`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/meaningful-sequence"
            }}>{`1.3.2`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/keyboard.html"
            }}>{`2.1.1 Keyboard`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/keyboard"
            }}>{`2.1.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/no_keyboard_trap.html"
            }}>{`2.1.2 No Keyboard Trap`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/no-keyboard-trap"
            }}>{`2.1.2`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/focus_order.html"
            }}>{`2.4.3 Focus Order`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/focus-order"
            }}>{`2.4.3`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/headings_and_labels.html"
            }}>{`2.4.6 Headings and Labels`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/headings-and-labels"
            }}>{`2.4.6`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/focus_visible.html"
            }}>{`2.4.7 Focus Visible`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/focus-visible"
            }}>{`2.4.7`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/name_role_value.html"
            }}>{`4.1.2 Name, Role, Value`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/TR/UNDERSTANDING-WCAG20/ensure-compat-rsv.html"
            }}>{`4.1.2`}</a>{`)`}</li>
        </ul></li>
    </ul>
    <h2 {...{
      "id": "accessibility-testing"
    }}>{`Accessibility testing`}</h2>
    <h3 {...{
      "id": "automated-test"
    }}>{`Automated test`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">
            Automated test environment
          </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.2 with VoiceOver
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />
            - Dynamic Assessment Plugin (DAP) version 1.8.0.0
            <br />- Carbon 10 - React and vanilla
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>DAP test:</strong>
            <br />- No violations
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "macos-screen-reader-tests"
    }}>{`macOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.2 with VoiceOver
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />- Carbon 10 - React and vanilla
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) Test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                The Tab key and Shift-Tab navigate between accordion headers. VO
                announces, expand/collapse, title, collapsed, button, the
                button's state (expanded or collapsed), list, 1 item. You are
                currently on a button...
              </ListItem>
              <ListItem mdxType="ListItem">
                Press Control-Option-Space (or Space) to expand or collapse the
                accordion panel. VO announces expand/collapse title, the
                button's state (expanded or collapsed).
              </ListItem>
              <ListItem mdxType="ListItem">
                With the second or third accordion header expanded, Press
                Control-Option-Right Arrow. VO announces, the accordion panel
                content and the line number in the list. 4. Press
                Control-Option-Left Arrow - VO announces reads the accordion
                header again.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.2 with VoiceOver
            <br />
            - Safari version 12.0.2
            <br />- Carbon 10 - React and vanilla
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                The Tab key and Shift-Tab navigate between accordion headers. VO
                announces, expand/collapse, title, collapsed, button, the
                button's state (expanded or collapsed), group.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press Control-Option-Space (or Space) to expand or collapse the
                accordion panel. VO announces expand/collapse title, the
                button's state (expanded or collapsed).
              </ListItem>
              <ListItem mdxType="ListItem">
                With the second or third accordion header expanded, Press
                Control-Option-Right Arrow. VO announces, the accordion panel
                content and the line number in the list. Your are currently on a
                text area.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press Control-Option-Left Arrow - VO announces reads the
                accordion header again.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "windows-screen-reader-tests"
    }}>{`Windows screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment</StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - JAWS 19.1903.47
            <br />
            - Firefox version 67
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                The Tab key and Shift-Tab navigate between accordion headers.
                JAWS announces, title, and expand/collapse status.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Enter or Space key on the title. JAWS announces expand
                or collapsed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Navigate the text using the Up and Down Arrow keys, when JAWS
                read the headers and associated text if expanded in a linear
                order.
              </ListItem>
              <ListItem mdxType="ListItem">
                Please note that sometimes it takes a second for the text to
                update after a title is expanded. When pressing the down arrow
                key immediately after JAWS announces "expanded", JAWS jumps past
                the text and reads the next title.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - JAWS 19.1903.47
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                The Tab key and Shift-Tab navigate between accordion headers.
                JAWS announces, title, and expand/collapse status.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Enter or Space key on the title. JAWS announces expand
                or collapsed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Navigate the text using the Up and Down Arrow keys, when JAWS
                read the headers and associated text if expanded in a linear
                order.
              </ListItem>
              <ListItem mdxType="ListItem">
                Please note that sometimes it takes a second for the text to
                update after a title is expanded. When pressing the down arrow
                key immediately after JAWS announces "expanded", JAWS jumps past
                the text and reads the next title.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - NVDA version 2018.4.1
            <br />
            - Chrome version 72.0.3626.96 (Official Build) (64-bit)
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>NVDA test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                The Tab key and Shift-Tab navigate between accordion headers.
                NVDA announces, title, and expand/collapse status.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Enter or Space key on the title. NVDA announces expand
                or collapsed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Navigate the text using the Up and Down Arrow keys, when JAWS
                read the headers and associated text if expanded in a linear
                order.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "ios-screen-reader-tests"
    }}>{`iOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListRow head mdxType="StructuredListRow">
        <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
        <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
      </StructuredListRow>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - iOS version 13.1.3 with VoiceOver
            <br />
            - Safari version 13.1.3
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                To navigate the accordion, swipe left or right, or use the Left
                or Right Arrow keys when quick nav mode is on. On each header,
                VoiceOver announces the header, and expanded/collapsed status.
              </ListItem>
              <ListItem mdxType="ListItem">
                To expand or collapse the accordion, doubletap on the header, or
                press Control+Option+Space. VoiceOver announces, exapnaded or
                collapses.
              </ListItem>
              <ListItem mdxType="ListItem">
                In some cases, VoiceOver also reads out the entire header, it
                seems to happen randomly, possibly have to do with the speed of
                the phone.
              </ListItem>
              <ListItem mdxType="ListItem">
                Navigate the text by swiping left or right, or by pressing the
                Left or Right Arrow keys when quick navigation mode is on. After
                each title, when moving to the left or right, VoiceOver will
                read the text if it is expanded.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "android-screen-reader-tests"
    }}>{`Android screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Android version 9 with Talkback
            <br />
            - Chrome version 72.0.3626.96 (Official Build) (64-bit)
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>Talkback test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                To navigate the accordion, swipe left or right, or use the
                Alt+Left or Right Arrow keys. On each header, TalkBack announces
                the header, and expanded/collapsed status.
              </ListItem>
              <ListItem mdxType="ListItem">
                To expand or collapse the accordion, doubletap on the header, or
                press Alt+Enter. Talkback announces expanded or collapses.
              </ListItem>
              <ListItem mdxType="ListItem">
                Navigate the text by swiping left or right, or by pressing the
                Left or Right Arrow keys. After each title, when moving to the
                left or right, Talkback will read the text if it is expanded.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      